import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* isReadonly(action: ActionInterface): any {
  try {
    yield put({
        type: Constants.GLOBAL_IS_READONLY_REQUEST
    });

    const res = yield call(Http.get, `${action.payload?.entity}/${action.payload?.contract.id}/is-readonly`);

    yield put({
      type: Constants.GLOBAL_IS_READONLY_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchIsReadonly() {
  yield takeEvery(Constants.GLOBAL_IS_READONLY_START, isReadonly);
}
